export const HAND_JOINTS = [
  "wrist", "thumb-metacarpal", "thumb-phalanx-proximal", "thumb-phalanx-distal", "thumb-tip",
  ...["index", "middle", "ring", "pinky"].flatMap((finger) =>
    ["metacarpal", "phalanx-proximal", "phalanx-intermediate", "phalanx-distal", "tip"].map((joint) => `${finger}-finger-${joint}`)),
];

// Validate the whole hand before updating any bones. Never display a mixture of
// current and stale finger poses when tracking is interrupted or incomplete.
export function readHandPose(frame, source, referenceSpace, poses) {
  if (!frame || !source?.hand || !referenceSpace) return false;
  try {
    for (let i = 0; i < HAND_JOINTS.length; i++) {
      const joint = source.hand.get(HAND_JOINTS[i]);
      const pose = joint && frame.getJointPose(joint, referenceSpace);
      const matrix = pose?.transform?.matrix;
      if (!matrix || matrix.length !== 16 || !matrix.every(Number.isFinite)) return false;
      poses[i] = pose;
    }
    return true;
  } catch {
    return false;
  }
}
